import { render, staticRenderFns } from "./populateBatchModal.vue?vue&type=template&id=6d8c509d&"
import script from "./populateBatchModal.vue?vue&type=script&lang=js&"
export * from "./populateBatchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports